import type { Client } from '../../api/client.js';
import { chargerRequete, type EtatRequete } from '../../api/requete.js';
import { piecesVisiblesParLeNotaire } from '../clerc/chargement.js';
import type { DossierNotaire, PieceDossier } from '../clerc/types.js';

export interface DonneesNotaire {
  dossier: DossierNotaire;
  pieces: PieceDossier[];
}

export const MESSAGE_AUTRE_DOSSIER = 'Ce dossier ne fait pas partie de ceux que vous suivez avec le Cabinet MAAT.';

/**
 * Lit le dossier demandé. L’isolation entre notaires (#55) est tenue par l’API ; ici, défense en profondeur :
 * une réponse qui porte un autre dossier que celui demandé n’est jamais affichée.
 */
export async function chargerEspaceNotaire(client: Client, dossierId: string): Promise<EtatRequete<DonneesNotaire>> {
  const parametres = { dossierId };
  const dossier = await chargerRequete<DossierNotaire>(client, 'notaire.dossier', { parametres });
  if (dossier.etat === 'erreur') return dossier;
  if (dossier.etat !== 'ok') return { etat: dossier.etat === 'vide' ? 'vide' : 'chargement' };
  if (dossier.donnees.id !== dossierId) return { etat: 'erreur', message: MESSAGE_AUTRE_DOSSIER };
  const pieces = await chargerRequete<PieceDossier[]>(client, 'documents.lister', { parametres });
  if (pieces.etat === 'erreur') return pieces;
  return {
    etat: 'ok',
    donnees: { dossier: dossier.donnees, pieces: pieces.etat === 'ok' ? piecesVisiblesParLeNotaire(pieces.donnees) : [] },
  };
}
